export enum $recentUserResources {
  workspaceIds = 'workspaceIds',
  digitalPropertyIds = 'digitalPropertyIds',
  tenantId = 'tenantId',
}

export enum $recentUserWorkspace {
  workspaceId = 'workspaceId',
  workspaceName = 'workspaceName',
  riskScore = 'riskScore',
}

export const RECENT_USER_RESOURCES_LIMIT: number = 4;
